export const RATIO_EXTRA_THICK = 5.0;
export const RATIO_THICK = 5.5;
export const RATIO_NORMAL = 7.5;
export const RATIO_THIN = 9.5;
export const RATIO_EXTRA_THIN = 11.5;
